import jwt from 'jsonwebtoken';

export function setUser(apikey, account){
    sessionStorage.setItem("account", JSON.stringify(account))
    sessionStorage.setItem("apikey", apikey)
    console.log(apikey,apikey)
}

export function getUser(){
    let user = sessionStorage.getItem("account")
    return JSON.parse(user)
}

export function getAPIKEY(){
    return sessionStorage.getItem("apikey")
}

export function LogoutUser(){
    sessionStorage.removeItem("account")
    sessionStorage.removeItem("apikey")
}

export function isLoggedIn(){
    let token = sessionStorage.getItem("apikey")
    if (token && jwt.decode(token)) {
        const expiry = jwt.decode(token).exp;
        const now = new Date();
        return !(now.getTime() > expiry * 1000);
    }
    return false;
}